import { configureStore } from '@reduxjs/toolkit'
import { sessionSlice } from './slices/session';
import { sessionCustomerSlice } from './slices/session-customer';

const store = configureStore({
  reducer: {
    session: sessionSlice.reducer,
    sessioncustomer: sessionCustomerSlice.reducer
  }
});

export default store;

